export const USER = 'user';
export const USER_AUTH_LOGIN = 'USER_AUTH_LOGIN';
export const USER_AUTH_LOGOUT = 'USER_AUTH_LOGOUT';
export const USER_CUSTOMER = 'USER_CUSTOMER';
export const USER_ORDERS = 'USER_ORDERS';
export const INCADEA_ORDERS = 'INCADEA_ORDERS';
export const USER_ORDER = 'USER_ORDER';
export const USER_SHOPPING_LIST = 'USER_SHOPPING_LIST';

export const USER_LOGGEDIN = 'USER_LOGGEDIN';
export const USER_LOGGEDOUT = 'USER_LOGGEDOUT';
